import React from 'react';

const Testimonials = () => {
  return (
    <section className="px-6 py-20 bg-gradient-to-r from-blue-50 via-purple-50 to-green-50 md:px-12">
      <div className="mx-auto text-center max-w-7xl">
        <h2 className="mb-4 text-4xl font-extrabold text-gray-800">What Parents & Students Say</h2>
        <p className="max-w-2xl mx-auto mb-12 text-lg text-gray-600">
          Real voices from our global family sharing their Blessed Montessori experiences.
        </p>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {/* Testimonial 1 */}
          <div className="p-6 transition transform bg-white shadow-lg rounded-xl hover:shadow-2xl hover:scale-105">
            <p className="mb-4 italic text-gray-600">
              "Blessed Montessori gave my child a foundation of confidence and curiosity. Their love for learning started here."
            </p>
            <div className="flex items-center space-x-4">
              <img
                src="https://randomuser.me/api/portraits/women/65.jpg"
                alt="Parent"
                className="object-cover w-12 h-12 rounded-full"
              />
              <div className="text-left">
                <p className="font-semibold text-gray-800">Mrs. Amina Yusuf</p>
                <p className="text-sm text-gray-500">Parent, Abuja</p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="p-6 transition transform bg-white shadow-lg rounded-xl hover:shadow-2xl hover:scale-105">
            <p className="mb-4 italic text-gray-600">
              "Their teachers are patient, passionate, and always go the extra mile. I loved every minute I spent here!"
            </p>
            <div className="flex items-center space-x-4">
              <img
                src="https://randomuser.me/api/portraits/men/45.jpg"
                alt="Student"
                className="object-cover w-12 h-12 rounded-full"
              />
              <div className="text-left">
                <p className="font-semibold text-gray-800">Daniel Eze</p>
                <p className="text-sm text-gray-500">Alumnus, Lagos</p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="p-6 transition transform bg-white shadow-lg rounded-xl hover:shadow-2xl hover:scale-105">
            <p className="mb-4 italic text-gray-600">
              "A world-class school environment with a heart. Blessed Montessori truly lives up to its name."
            </p>
            <div className="flex items-center space-x-4">
              <img
                src="https://randomuser.me/api/portraits/women/22.jpg"
                alt="Parent"
                className="object-cover w-12 h-12 rounded-full"
              />
              <div className="text-left">
                <p className="font-semibold text-gray-800">Dr. Linda Umeh</p>
                <p className="text-sm text-gray-500">Parent, London</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
